import axios from "axios";
import { API_BASE_URL } from "@/config/api";

export const queryTravelRoutes = (params) => {
  return axios.get(`${API_BASE_URL}/app/route/list`, { params });
};
